var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMyTextDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 44"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#777",
  strokeWidth: 1.6,
  clipPath: "url(#icon_my_text_dark_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M18.27 18.175h11.46a.5.5 0 0 1 .471.333l2.168 6.142H15.631l2.168-6.142a.5.5 0 0 1 .47-.333Z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M24 7.36a3.95 3.95 0 1 1 0 7.9 3.95 3.95 0 0 1 0-7.9Z"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#777",
  d: "M20.104 31.95v5.683h-4.092v-5.684zm-3.184 4.93h2.265v-4.198H16.92zm4.648 2.95v-8.75h.928v3.428h1.406v.781h-1.406v4.541zm10-8.75v8.77h-.927v-8.77zm-6.943 3.72c0-1.87.942-3.06 2.266-3.066 1.299.005 2.256 1.197 2.256 3.067 0 1.89-.957 3.08-2.256 3.076-1.324.005-2.266-1.187-2.266-3.076m.898 0c-.004 1.392.552 2.247 1.368 2.247.8 0 1.357-.855 1.357-2.246 0-1.372-.557-2.232-1.357-2.236-.816.004-1.372.864-1.368 2.236"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon_my_text_dark_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11 3h26v26H11z"
})))));
export default SvgIconMyTextDark;